import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/Icon';

const DeleteSection = ({ name, onClickDeleteBtn }) => (
    <div className="sideloaded-delete-section">
        <div className="sideloaded-delete-section-header-row">
            <h3 className="sideloaded-delete-section-header">Delete App</h3>
            <button type="button" className="sg-button-link sideloaded-delete-app-btn" onClick={onClickDeleteBtn}>
                <Icon alias="delete" />
                Delete&nbsp;App
            </button>
        </div>
        <p className="sideloaded-delete-section-caption">This action will uninstall {name} from users accounts.</p>
    </div>
);

DeleteSection.propTypes = {
    name: PropTypes.string.isRequired,
    onClickDeleteBtn: PropTypes.func.isRequired,
};

export default DeleteSection;
